import { ArrowUpRight, Link2 } from "lucide-react";
import { FaInstagram } from "react-icons/fa6";
import { MdVerified } from "react-icons/md";
import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const AVATAR = "https://customer-assets-agu9un31.emergentagent.net/job_timbodaking-media/artifacts/tqqq5iww_image.png";

const stats = [
  { value: "817", label: "posts" },
  { value: "4.1M", label: "followers" },
  { value: "3,816", label: "following" },
];

export default function InstagramCTA({ url = "https://www.instagram.com/timbaland" }) {
  return (
    <section className="relative overflow-hidden py-24 md:py-32 border-b border-white/10" data-testid="instagram-cta">
      <div
        className="absolute inset-0"
        style={{ background: "radial-gradient(circle at 50% 30%, rgba(79, 176, 74,0.14), transparent 60%), radial-gradient(circle at 85% 85%, rgba(45,143,79,0.16), transparent 55%)" }}
      />
      {/* Blended gold logo behind */}
      <img
        src="/timbo-green.png"
        alt=""
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-[10%] -translate-x-1/2 w-[70%] max-w-[820px] opacity-[0.06] object-contain"
      />

      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal className="text-center mb-12 md:mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <FaInstagram className="text-gold" size={24} />
            <span className="font-display uppercase tracking-[0.22em] text-xs text-white/60">Follow The Journey</span>
          </div>
          <h2 className="headline text-5xl md:text-7xl text-white">Straight from the source.</h2>
        </Reveal>

        {/* Instagram profile card */}
        <Reveal delay={0.1} className="max-w-3xl mx-auto">
          <motion.div
            whileHover={{ y: -4 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            data-testid="ig-profile-card"
            className="relative rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-xl p-6 md:p-10 overflow-hidden"
          >
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 md:gap-10">
              {/* Avatar with IG gradient ring */}
              <div className="shrink-0 rounded-full p-[3px]" style={{ background: "conic-gradient(from 210deg, #feda75, #fa7e1e, #d62976, #962fbf, #4f5bd5, #feda75)" }}>
                <div className="rounded-full p-[3px] bg-obsidian">
                  <div className="w-24 h-24 md:w-32 md:h-32 rounded-full overflow-hidden">
                    <img
                      src={AVATAR}
                      alt="timbaland"
                      className="w-full h-full object-cover scale-[1.38] object-[center_26%]"
                    />
                  </div>
                </div>
              </div>

              <div className="flex-1 text-center sm:text-left">
                <div className="flex items-center justify-center sm:justify-start gap-2 mb-1">
                  <span className="font-display text-2xl md:text-3xl text-white lowercase tracking-tight">timbaland</span>
                  <MdVerified className="text-[#3897f0]" size={22} />
                </div>
                <p className="font-body text-white/70 mb-5">Timbo the King</p>

                <div className="flex items-center justify-center sm:justify-start gap-8 md:gap-12 mb-5">
                  {stats.map((s) => (
                    <div key={s.label} className="text-center sm:text-left">
                      <p className="font-display text-xl md:text-2xl text-white leading-none">{s.value}</p>
                      <p className="font-body text-xs uppercase tracking-[0.12em] text-white/45 mt-1">{s.label}</p>
                    </div>
                  ))}
                </div>

                <p className="font-body text-white/60 text-sm mb-2">Entrepreneur</p>
                <a
                  href="https://timbaland.bio"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 font-body text-sm text-gold hover:text-white transition-colors"
                >
                  <Link2 size={14} /> timbaland.bio
                </a>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-white/10 flex justify-center sm:justify-end">
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="instagram-follow-btn"
                className="group inline-flex items-center gap-3 bg-gold text-black font-display uppercase tracking-[0.2em] text-sm px-9 py-4 hover:bg-white transition-colors duration-300 rounded-full"
              >
                Follow on Instagram
                <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
              </a>
            </div>
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
}
